import {
  Button,
  Caption,
  Dropdown,
  Input,
  StyledModal,
  Switch,
} from "@bikdotai/bik-component-library";
import {
  EachTailoredSectionI,
  EachWhatsNewContent,
  JourneyLevels,
  PrimaryButtonAction,
  SecondaryButtonAction,
  UiMeta,
} from "../type";
import {
  DropdownOption,
  SingleOption,
} from "@bikdotai/bik-component-library/dist/esm/components/dropdown/type";
import { MenuItems } from "..";
import { LegacyRef, useEffect, useMemo, useRef, useState } from "react";
import {
  AddOrEditFeatureModalContainer,
  BackgroundImageContainer,
} from "../style";
import { AllModules } from "@bikdotai/bik-models/growth/models/feature";
import { GrowthRepo } from "../GrowthRepo";
import RichTextEditor from "../../../ui-components/rich-text-editor/RichTextEditor";
import React from "react";
import { UploadFile } from "../../../ui-components/file-uploader/fileUploader";
import { WHATS_NEW_VALIDATION } from "../../../features/whats-new/types/whatsNew.types";
import DeleteIcon from "../../../icons/DeleteIcon";
import ShapeIcon from "../../../icons/ShapeIcon";
import ImageUploadModal from "../../../components/upload-modals/ImageUploadModal";
import VideoUploadModal from "../../../components/upload-modals/VideoUploadModal";

const VideoPlayer: React.FC<{ src: string }> = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlay = async () => {
    if (videoRef.current) {
      try {
        if (isPlaying) {
          videoRef.current.pause();
          setIsPlaying(false);
        } else {
          await videoRef.current.play();
          setIsPlaying(true);
        }
      } catch (error) {
        // Error playing video
      }
    }
  };

  return (
    <div
      style={{
        marginTop: "12px",
        border: "1px solid #d1d5db",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#000",
        position: "relative",
        cursor: "pointer",
      }}
      onClick={togglePlay}
    >
      <video
        ref={videoRef}
        src={src}
        style={{
          width: "100%",
          height: "200px",
          objectFit: "cover",
        }}
        muted
        preload="metadata"
        playsInline
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        onLoadedData={() => {
          // Video loaded successfully
        }}
        onError={(e) => {
          // Video loading error
        }}
      />
      {!isPlaying && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: 0,
              height: 0,
              borderLeft: "12px solid white",
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              marginLeft: "3px",
            }}
          />
        </div>
      )}
    </div>
  );
};

interface AddOrEditFeatureModalI {
  isOpen: boolean;
  onCloseModal: (reload?: boolean) => void;
  curentMenu: string; //keyof typeof MenuList;
  operationtype: "add" | "edit";
  moduleMenu?: string;
  menuItemToEdit?: EachTailoredSectionI | UiMeta | EachWhatsNewContent;
  indexToUpdate?: number | string;
}

const DefaultErrorMessages = {
  section: "",
  module: "",
  level: "",
  title: "",
  desc: "",
  image: "",
  body: "",
  featureUpdateType: "",
  featureTag: "",
  pageUrls: "",
  displayImage: "",
  productVideo: "",
  maxDisplayDuration: "",
  primaryButtonText: "",
  primaryButtonAction: "",
  primaryButtonRedirectionUrl: "",
  secondaryButtonText: "",
  secondaryButtonAction: "",
  secondaryButtonRedirectionUrl: "",
};
const DEFAULT_BG =
  "https://firebasestorage.googleapis.com/v0/b/bikayi-chat.appspot.com/o/images-uid%2F1c11e926-f67d-4325-a6d7-cd665dbedef4?alt=media&token=20a8a8f3-d6a8-4e41-871f-5d06772476ab";
const DEFAULT_WHATS_NEW =
  "https://firebasestorage.googleapis.com/v0/b/staging-bikayi.appspot.com/o/images-uid%2F8fb1d6a7-bc56-4512-859b-67f4a9282f61?alt=media&token=27f15953-0938-4d05-bce0-3b1061c75851";

const AddOrEditFeatureModal: React.FC<AddOrEditFeatureModalI> = ({
  isOpen,
  onCloseModal,
  curentMenu,
  operationtype,
  moduleMenu,
  menuItemToEdit,
  indexToUpdate,
}) => {
  const growthRepo = useMemo(() => new GrowthRepo(), []);
  const [updating, setUpdating] = useState(false);
  function isEachTailoredSectionI(
    item: EachTailoredSectionI | UiMeta | EachWhatsNewContent | undefined
  ): item is EachTailoredSectionI {
    return (
      item !== undefined &&
      "level" in item &&
      typeof (item as EachTailoredSectionI)?.level === "string"
    );
  }
  const [SectionList, setSectionList] = useState(
    MenuItems.slice(0, 2).map((item) => ({
      value: item.key,
      label: item.displayName,
      selected: curentMenu === item.key,
    }))
  );
  const [LevelList, setLevelList] = useState(
    Object.values(JourneyLevels).map((key) => ({
      value: key,
      label: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(),
      selected:
        isEachTailoredSectionI(menuItemToEdit) && menuItemToEdit?.level === key,
    }))
  );
  const [ModuleList, setModuleList] = useState(
    Object.values(AllModules).map((key) => ({
      value: key,
      label: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(),
      selected: moduleMenu === key,
    }))
  );

  const [FeatureUpdateTypeList, setFeatureUpdateTypeList] = useState([
    { value: "Minor", label: "Minor", selected: false },
    { value: "Major", label: "Major", selected: false },
  ]);

  const [PrimaryButtonActionList, setPrimaryButtonActionList] = useState([
    { value: PrimaryButtonAction.PLAY_VIDEO, label: "Play Video", selected: false },
    { value: PrimaryButtonAction.OPEN_LINK, label: "Open link", selected: true },
  ]);

  const [SecondaryButtonActionList, setSecondaryButtonActionList] = useState([
    { value: PrimaryButtonAction.PLAY_VIDEO, label: "Play Video", selected: false },
    { value: SecondaryButtonAction.OPEN_LINK, label: "Open link", selected: false },
    { value: SecondaryButtonAction.CLOSE_POPUP, label: "Close popup", selected: false },
  ]);

  const [WhatsNewModuleList, setWhatsNewModuleList] = useState([
    { value: "Helpdesk", label: "Helpdesk", selected: false },
    { value: "Campaigns", label: "Campaigns", selected: false },
    { value: "Journeys", label: "Journeys", selected: false },
    { value: "Popups", label: "Popups", selected: false },
    { value: "Manifest", label: "Manifest", selected: false },
  ]);

  const [formDetails, setFormDetails] = useState({
    section: curentMenu,
    module: moduleMenu,
    level: isEachTailoredSectionI(menuItemToEdit) ? menuItemToEdit.level : "",
    title: "",
    desc: "",
    image: "",
  });
  const [bodyText, setBodyText] = useState({ body: "" });

  const [whatsNewDetails, setWhatsNewDetails] = useState({
    featureUpdateType: "" as "" | "Major" | "Minor",
    module: [] as string[],
    featureTag: "",
    pageUrls: [""],
    displayImage: "",
    productVideo: "",
    visibility: false,
    showInFeed: true,
    maxDisplayDuration: "60" as string,
    primaryButton: {
      text: "Learn More",
      action: PrimaryButtonAction.OPEN_LINK,
      redirectionUrl: "",
    },
    secondaryButton: {
      text: "Learn More",
      action: SecondaryButtonAction.NONE,
      redirectionUrl: "",
    },
  });

  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);

  const [errorMessage, setErrorMessage] = useState(DefaultErrorMessages);

  const dropdownRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (menuItemToEdit) {
      if (isEachTailoredSectionI(menuItemToEdit)) {
        setFormDetails({
          ...formDetails,
          title: menuItemToEdit.uiMeta.title,
          desc: menuItemToEdit.uiMeta.desc,
          image: menuItemToEdit.uiMeta.image,
        });
      } else if ("desc" in menuItemToEdit) {
        setFormDetails({
          ...formDetails,
          title: menuItemToEdit.title,
          desc: menuItemToEdit.desc,
          image: menuItemToEdit.image,
        });
      } else {
        const whatsNewItem = menuItemToEdit as EachWhatsNewContent;
        setFormDetails({
          ...formDetails,
          title: whatsNewItem.title,
          image: whatsNewItem.image,
        });
        setBodyText({ body: whatsNewItem.body });

        const moduleArray = Array.isArray(whatsNewItem.module)
          ? whatsNewItem.module
          : whatsNewItem.module
            ? [whatsNewItem.module]
            : [];

        const rawPrimary = whatsNewItem.primaryButton;
        const primaryButton = {
          text: rawPrimary?.text || "Learn More",
          action: rawPrimary?.action || PrimaryButtonAction.OPEN_LINK,
          redirectionUrl: rawPrimary?.redirectionUrl || "",
        };

        const rawSecondary = whatsNewItem.secondaryButton;
        const secondaryButton = {
          text: rawSecondary?.text || "Learn More",
          action: rawSecondary?.action || SecondaryButtonAction.NONE,
          redirectionUrl: rawSecondary?.redirectionUrl || "",
        };

        setWhatsNewDetails({
          featureUpdateType: whatsNewItem.featureUpdateType || "",
          module: moduleArray,
          featureTag: whatsNewItem.featureTag || "",
          pageUrls: whatsNewItem.pageUrls || [""],
          displayImage: whatsNewItem.displayImage || "",
          productVideo: whatsNewItem.productVideo || "",
          visibility:
            whatsNewItem.visibility !== undefined
              ? whatsNewItem.visibility
              : false,
          showInFeed:
            whatsNewItem.showInFeed !== false,
          maxDisplayDuration: whatsNewItem.maxDisplayDuration
            ? whatsNewItem.maxDisplayDuration.toString()
            : "60",
          primaryButton,
          secondaryButton,
        });

        if (whatsNewItem.featureUpdateType) {
          setFeatureUpdateTypeList(
            FeatureUpdateTypeList.map((item) => ({
              ...item,
              selected: item.value === whatsNewItem.featureUpdateType,
            }))
          );
        }
        if (primaryButton.action) {
          setPrimaryButtonActionList(
            PrimaryButtonActionList.map((item) => ({
              ...item,
              selected: item.value === primaryButton.action,
            }))
          );
        }
        if (secondaryButton.action) {
          setSecondaryButtonActionList(
            SecondaryButtonActionList.map((item) => ({
              ...item,
              selected: item.value === secondaryButton.action,
            }))
          );
        }
        setWhatsNewModuleList(
          WhatsNewModuleList.map((item) => ({
            ...item,
            selected: moduleArray.includes(item.value),
          }))
        );
      }
    } else {
      // Reset form for new item
      if (curentMenu === MenuItems[2].key) {
        setFormDetails({
          section: curentMenu,
          module: moduleMenu,
          level: "",
          title: "",
          desc: "",
          image: "",
        });
        setBodyText({ body: "" });
        setWhatsNewDetails({
          featureUpdateType: "",
          module: [],
          featureTag: "",
          pageUrls: [""],
          displayImage: "",
          productVideo: "",
          visibility: false,
          showInFeed: true,
          maxDisplayDuration: "60",
          primaryButton: {
            text: "Learn More",
            action: PrimaryButtonAction.OPEN_LINK,
            redirectionUrl: "",
          },
          secondaryButton: {
            text: "Learn More",
            action: SecondaryButtonAction.NONE,
            redirectionUrl: "",
          },
        });
        // Reset dropdown selections
        setFeatureUpdateTypeList(
          FeatureUpdateTypeList.map((item) => ({
            ...item,
            selected: false,
          }))
        );
        setPrimaryButtonActionList(
          PrimaryButtonActionList.map((item) => ({
            ...item,
            selected: item.value === PrimaryButtonAction.OPEN_LINK,
          }))
        );
        setSecondaryButtonActionList(
          SecondaryButtonActionList.map((item) => ({
            ...item,
            selected: false,
          }))
        );
        setWhatsNewModuleList(
          WhatsNewModuleList.map((item) => ({
            ...item,
            selected: false,
          }))
        );
      }
    }
  }, [menuItemToEdit]);

  useEffect(() => {
    if (
      isOpen &&
      operationtype === "add" &&
      !menuItemToEdit &&
      curentMenu === MenuItems[2].key
    ) {
      setWhatsNewDetails({
        featureUpdateType: "",
        module: [],
        featureTag: "",
        pageUrls: [""],
        displayImage: "",
        productVideo: "",
        visibility: false,
        showInFeed: true,
        maxDisplayDuration: "60",
        primaryButton: {
          text: "Learn More",
          action: PrimaryButtonAction.OPEN_LINK,
          redirectionUrl: "",
        },
        secondaryButton: {
          text: "Learn More",
          action: SecondaryButtonAction.NONE,
          redirectionUrl: "",
        },
      });
      setFeatureUpdateTypeList(
        FeatureUpdateTypeList.map((item) => ({
          ...item,
          selected: false,
        }))
      );
      setPrimaryButtonActionList(
        PrimaryButtonActionList.map((item) => ({
          ...item,
          selected: item.value === PrimaryButtonAction.OPEN_LINK,
        }))
      );
      setSecondaryButtonActionList(
        SecondaryButtonActionList.map((item) => ({
          ...item,
          selected: false,
        }))
      );
      setWhatsNewModuleList(
        WhatsNewModuleList.map((item) => ({
          ...item,
          selected: false,
        }))
      );
    }
  }, [isOpen, operationtype, menuItemToEdit, curentMenu]);

  const determineErrorMessage = (changed: string, type: string) => {
    if (!changed) {
      setErrorMessage({
        ...errorMessage,
        [type]: `Please enter a valid value for ${type}`,
      });
    } else {
      setErrorMessage({ ...errorMessage, [type]: "" });
    }
  };

  const addPageUrl = () => {
    setWhatsNewDetails({
      ...whatsNewDetails,
      pageUrls: [...whatsNewDetails.pageUrls, ""],
    });
  };

  const removePageUrl = (index: number) => {
    const newUrls = whatsNewDetails.pageUrls.filter((_, i) => i !== index);
    setWhatsNewDetails({
      ...whatsNewDetails,
      pageUrls: newUrls.length > 0 ? newUrls : [""],
    });
  };

  const updatePageUrl = (index: number, value: string) => {
    const newUrls = [...whatsNewDetails.pageUrls];
    newUrls[index] = value;
    setWhatsNewDetails({
      ...whatsNewDetails,
      pageUrls: newUrls,
    });
  };
  const submitAllFeatureDetails = async () => {
    setErrorMessage({ ...errorMessage, body: "" });
    const isWhatsNew = curentMenu === MenuItems[2].key;
    if (errorMessage.title || errorMessage.level) {
      return;
    }
    if (!isWhatsNew && errorMessage.desc) {
      return;
    }

    if (!formDetails.title) {
      const updatedErrorMessage = { ...errorMessage };
      updatedErrorMessage.title = "Title is required";
      setErrorMessage(updatedErrorMessage);
      return;
    }

    if (isWhatsNew && !bodyText.body) {
      setErrorMessage({ ...errorMessage, body: "Body is required" });
      return;
    }
    if (!isWhatsNew && !formDetails.desc) {
      setErrorMessage({ ...errorMessage, body: "Description is required" });
      return;
    }

    if (isWhatsNew) {
      if (!whatsNewDetails.featureUpdateType) {
        setErrorMessage({
          ...errorMessage,
          featureUpdateType: "Feature update type is required",
        });
        return;
      }
      if (whatsNewDetails.module.length === 0) {
        setErrorMessage({
          ...errorMessage,
          module: "At least one module is required",
        });
        return;
      }
      if (!whatsNewDetails.maxDisplayDuration) {
        setErrorMessage({
          ...errorMessage,
          maxDisplayDuration: "Maximum display duration is required",
        });
        return;
      }
      const maxDisplayDurationNumber = parseInt(
        whatsNewDetails.maxDisplayDuration
      );
      if (isNaN(maxDisplayDurationNumber) || maxDisplayDurationNumber <= 0) {
        setErrorMessage({
          ...errorMessage,
          maxDisplayDuration: "Please enter a valid number greater than 0",
        });
        return;
      }

      if (!whatsNewDetails.displayImage) {
        setErrorMessage({
          ...errorMessage,
          displayImage: "Display image is required",
        });
        return;
      }

      if (!whatsNewDetails.primaryButton.text) {
        setErrorMessage({
          ...errorMessage,
          primaryButtonText: "Primary button text is required",
        });
        return;
      }

      if (
        (whatsNewDetails.primaryButton.text || "").length >
        WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH
      ) {
        setErrorMessage({
          ...errorMessage,
          primaryButtonText: `Primary button text must not exceed ${WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH} characters`,
        });
        return;
      }

      if (!whatsNewDetails.secondaryButton.text) {
        setErrorMessage({
          ...errorMessage,
          secondaryButtonText: "Secondary button text is required",
        });
        return;
      }

      if (
        (whatsNewDetails.secondaryButton.text || "").length >
        WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH
      ) {
        setErrorMessage({
          ...errorMessage,
          secondaryButtonText: `Secondary button text must not exceed ${WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH} characters`,
        });
        return;
      }

      if (!whatsNewDetails.secondaryButton.action) {
        setErrorMessage({
          ...errorMessage,
          secondaryButtonAction: "Secondary button action is required",
        });
        return;
      }

      if (whatsNewDetails.primaryButton.action === PrimaryButtonAction.OPEN_LINK &&
        !whatsNewDetails.primaryButton.redirectionUrl) {
        setErrorMessage({
          ...errorMessage,
          primaryButtonRedirectionUrl: "Primary button redirection URL is required",
        });
        return;
      }

      // Secondary button URL is optional

      // Video is optional for all update types

      if (whatsNewDetails.featureUpdateType === "Major") {
        const validUrls = whatsNewDetails.pageUrls.filter(
          (url) => url.trim() !== ""
        );
      }
    }

    if (curentMenu === MenuItems[0].key && !formDetails.level) {
      if (!formDetails.level) {
        setErrorMessage({ ...errorMessage, level: "Level is required" });
      }
      return;
    }
    setUpdating(true);
    if (isWhatsNew) {
      const maxDisplayDurationNumber = parseInt(
        whatsNewDetails.maxDisplayDuration
      );
      const currentDate = new Date();
      const expirationDate = new Date(
        currentDate.getTime() + maxDisplayDurationNumber * 24 * 60 * 60 * 1000
      );

      const payload = {
        title: formDetails.title,
        body: bodyText["body"],
        image: whatsNewDetails.displayImage,
        redirectUrl: "",
        createdAt: new Date(),
        featureUpdateType: whatsNewDetails.featureUpdateType,
        module: whatsNewDetails.module,
        featureTag: whatsNewDetails.featureTag,
        pageUrls: whatsNewDetails.pageUrls.filter((url) => url.trim() !== ""),
        displayImage: whatsNewDetails.displayImage,
        productVideo: whatsNewDetails.productVideo,
        visibility: whatsNewDetails.visibility,
        showInFeed:
          whatsNewDetails.featureUpdateType === "Major"
            ? true
            : whatsNewDetails.showInFeed,
        updates: whatsNewDetails.featureUpdateType,
        content: bodyText["body"],
        primaryButton: whatsNewDetails.primaryButton,
        secondaryButton: whatsNewDetails.secondaryButton,
        maxDisplayDuration: maxDisplayDurationNumber,
        expirationDate: expirationDate,
      };

      console.log("What's New payload being saved:", payload);

      await growthRepo.createOrUpdateArticleDocument(
        payload,
        operationtype === "edit"
          ? typeof indexToUpdate == "string"
            ? indexToUpdate
            : undefined
          : undefined
      );
      setUpdating(false);
      onCloseModal(true);
      return;
    }
    if (curentMenu === MenuItems[0].key) {
      const payload = {
        uiMeta: {
          title: formDetails.title,
          desc: formDetails.desc,
          image: formDetails.image || DEFAULT_BG,
          redirectUrl: "",
        },
        level: formDetails.level as JourneyLevels,
      };
      await growthRepo.updateFeatureDetails(
        formDetails.module || "",
        payload,
        operationtype === "edit" ? Number(indexToUpdate) : undefined
      );
    } else {
      const payload = {
        title: formDetails.title,
        desc: formDetails.desc,
        image: formDetails.image || DEFAULT_BG,
        redirectUrl: "",
      };
      await growthRepo.updateFeatureDetails(
        "also-try",
        payload,
        operationtype === "edit" ? Number(indexToUpdate) : undefined
      );
    }
    setUpdating(false);
    onCloseModal(true);
  };

  return (
    <>
      <StyledModal
        open={isOpen}
        headingTitle="Enter the feature details"
        onClose={onCloseModal}
        width="520px"
      >
        <AddOrEditFeatureModalContainer>
          {curentMenu !== MenuItems[2].key && (
            <div className="each--section">
              <Caption>Section</Caption>
              <Dropdown
                options={SectionList as DropdownOption[]}
                placeHolder="Select section"
                disabled={!!moduleMenu}
                onSelect={(selected) => {
                  setSectionList(
                    SectionList.map((item) => ({
                      ...item,
                      selected:
                        (selected as SingleOption)["value"] === item.value,
                    }))
                  );
                  setFormDetails({
                    ...formDetails,
                    section: (selected as SingleOption)["value"],
                  });
                }}
              ></Dropdown>
            </div>
          )}

          {curentMenu === MenuItems[0].key && (
            <div className="each--section">
              <Caption>Module</Caption>
              <Dropdown
                options={ModuleList as DropdownOption[]}
                placeHolder="Select Module"
                disabled={!!moduleMenu}
                onSelect={(selected) => {
                  setModuleList(
                    ModuleList.map((item) => ({
                      ...item,
                      selected:
                        (selected as SingleOption)["value"] === item.value,
                    }))
                  );
                  setFormDetails({
                    ...formDetails,
                    module: (selected as SingleOption)["value"],
                  });
                }}
              ></Dropdown>
            </div>
          )}
          {curentMenu === MenuItems[0].key && (
            <div className="each--section">
              <Caption>Level</Caption>
              <Dropdown
                options={LevelList}
                placeHolder="Select level"
                onSelect={(option) => {
                  determineErrorMessage(
                    (option as SingleOption).value,
                    "level"
                  );
                  setLevelList(
                    LevelList.map((item) => ({
                      ...item,
                      selected:
                        (option as SingleOption)["value"] === item.value,
                    }))
                  );
                  setFormDetails({
                    ...formDetails,
                    level: (option as SingleOption)["value"],
                  });
                }}
                error={errorMessage.level}
              ></Dropdown>
            </div>
          )}
          <div className="each--section">
            <Caption>
              Feature title <span style={{ color: "red" }}>*</span>
            </Caption>
            <Input
              value={formDetails.title}
              onChangeText={(changed) => {
                determineErrorMessage(changed, "title");
                setFormDetails({ ...formDetails, title: changed });
              }}
              errorMessage={errorMessage.title}
              state={
                curentMenu !== MenuItems[2].key
                  ? operationtype === "edit"
                    ? "disabled"
                    : "none"
                  : "none"
              }
            ></Input>
          </div>
          {curentMenu === MenuItems[2].key && (
            <div className="each--section">
              <Caption>
                Description <span style={{ color: "red" }}>*</span>
              </Caption>
              <RichTextEditor
                setSelectedVariableList={() => { }}
                selectedVariableList={[]}
                setHtmlMessage={setBodyText}
                htmlMessage={bodyText.body}
                showVariableOnly={false}
                customHeight={"72px"}
                placeHolder={"Enter note"}
                uniqueId={"body"}
                errorText={errorMessage.body}
                hideWordLimit={true}
                hideAddVariables={true}
              />
            </div>
          )}

          {/* What's New specific fields */}
          {curentMenu === MenuItems[2].key && (
            <>
              <div className="each--section">
                <Caption>
                  Feature update type <span style={{ color: "red" }}>*</span>
                </Caption>
                <div ref={dropdownRef as LegacyRef<HTMLDivElement> | undefined}>
                  <Dropdown
                    width={
                      dropdownRef?.current?.offsetWidth
                        ? `${dropdownRef?.current?.offsetWidth}px`
                        : "100%"
                    }
                    options={FeatureUpdateTypeList}
                    placeHolder="Select"
                    onSelect={(option) => {
                      const selectedValue = (option as SingleOption)[
                        "value"
                      ] as "Major" | "Minor";

                      setFeatureUpdateTypeList(
                        FeatureUpdateTypeList.map((item) => ({
                          ...item,
                          selected: selectedValue === item.value,
                        }))
                      );

                      const updatedDetails = {
                        ...whatsNewDetails,
                        featureUpdateType: selectedValue,
                      };

                      if (selectedValue === "Major") {
                        updatedDetails.featureTag = "";
                        // For Major: secondary button action should be "Open link"
                        updatedDetails.secondaryButton = {
                          ...updatedDetails.secondaryButton,
                          action: SecondaryButtonAction.OPEN_LINK
                        };
                        setSecondaryButtonActionList(
                          SecondaryButtonActionList.map((item) => ({
                            ...item,
                            selected: item.value === SecondaryButtonAction.OPEN_LINK,
                          }))
                        );

                        // For Major: primary button action should be "Play Video"
                        updatedDetails.primaryButton = {
                          ...updatedDetails.primaryButton,
                          action: PrimaryButtonAction.PLAY_VIDEO
                        };
                        setPrimaryButtonActionList(
                          PrimaryButtonActionList.map((item) => ({
                            ...item,
                            selected: item.value === PrimaryButtonAction.PLAY_VIDEO,
                          }))
                        );
                      } else if (selectedValue === "Minor") {
                        // For Minor: secondary button action should be "Close popup"
                        updatedDetails.secondaryButton = {
                          ...updatedDetails.secondaryButton,
                          action: SecondaryButtonAction.CLOSE_POPUP
                        };
                        setSecondaryButtonActionList(
                          SecondaryButtonActionList.map((item) => ({
                            ...item,
                            selected: item.value === SecondaryButtonAction.CLOSE_POPUP,
                          }))
                        );
                      }

                      setWhatsNewDetails(updatedDetails);
                      setErrorMessage({
                        ...errorMessage,
                        featureUpdateType: "",
                      });
                    }}
                    error={errorMessage.featureUpdateType}
                  ></Dropdown>
                </div>
              </div>{" "}
              {whatsNewDetails.featureUpdateType === "Minor" && (
                <div className="each--section">
                  <Caption>Show in What's New feed</Caption>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "4px",
                    }}
                  >
                    <Switch
                      value={whatsNewDetails.showInFeed}
                      onValueChange={async (val: boolean) =>
                        setWhatsNewDetails({ ...whatsNewDetails, showInFeed: val })
                      }
                      type="brand"
                    />
                    <span style={{ fontSize: "13px", color: "#444" }}>
                      {whatsNewDetails.showInFeed
                        ? "Visible in feed"
                        : "Hidden from feed"}
                    </span>
                  </div>
                </div>
              )}
              <div className="each--section">
                <Caption>
                  Module <span style={{ color: "red" }}>*</span>
                </Caption>
                <div ref={dropdownRef as LegacyRef<HTMLDivElement> | undefined}>
                  <Dropdown
                    width={
                      dropdownRef?.current?.offsetWidth
                        ? `${dropdownRef?.current?.offsetWidth}px`
                        : "100%"
                    }
                    inputType="chip"
                    isMultiSelect
                    onClose={() => { }}
                    onDeleteChip={(deletedOption) => {
                      if (deletedOption && "value" in deletedOption) {
                        const updatedModuleList = WhatsNewModuleList.map(
                          (item) =>
                            item.value === deletedOption.value
                              ? { ...item, selected: false }
                              : item
                        );

                        setWhatsNewModuleList(updatedModuleList);

                        const selectedModules = updatedModuleList
                          .filter((item) => item.selected)
                          .map((item) => item.value);

                        setWhatsNewDetails({
                          ...whatsNewDetails,
                          module: selectedModules,
                        });
                      }
                    }}
                    onDropdownItemClick={() => { }}
                    onInfiniteScroll={() => { }}
                    onMultiSelectClear={() => {
                      setWhatsNewModuleList(
                        WhatsNewModuleList.map((item) => ({
                          ...item,
                          selected: false,
                        }))
                      );
                      setWhatsNewDetails({
                        ...whatsNewDetails,
                        module: [],
                      });
                    }}
                    onSearch={async (key: string) => {
                      return WhatsNewModuleList.filter((item) =>
                        item.label.toLowerCase().includes(key.toLowerCase())
                      );
                    }}
                    onSelect={(selectedOptions) => {
                      let selectedValues: string[] = [];

                      if (Array.isArray(selectedOptions)) {
                        selectedValues = selectedOptions
                          .filter(
                            (option): option is SingleOption =>
                              "value" in option
                          )
                          .map((option) => option.value);
                      } else if (
                        selectedOptions &&
                        "value" in selectedOptions
                      ) {
                        selectedValues = [selectedOptions.value];
                      }

                      setWhatsNewModuleList(
                        WhatsNewModuleList.map((item) => ({
                          ...item,
                          selected: selectedValues.includes(item.value),
                        }))
                      );

                      const updatedDetails = {
                        ...whatsNewDetails,
                        module: selectedValues,
                      };

                      // If only Manifest is selected, default to /home path
                      if (
                        selectedValues.length === 1 &&
                        selectedValues[0] === "Manifest"
                      ) {
                        updatedDetails.pageUrls = [
                          WHATS_NEW_VALIDATION.MANIFEST_DEFAULT_PATH,
                        ];
                      }

                      setWhatsNewDetails(updatedDetails);

                      setErrorMessage({ ...errorMessage, module: "" });
                    }}
                    options={WhatsNewModuleList}
                    version="1.0"
                    size="default"
                  />
                </div>
                {errorMessage.module && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {errorMessage.module}
                  </div>
                )}
              </div>
              <div className="each--section">
                <Caption>
                  Maximum display duration{" "}
                  <span style={{ color: "red" }}>*</span>
                </Caption>
                <div style={{ position: "relative" }}>
                  <Input
                    value={whatsNewDetails.maxDisplayDuration}
                    onChangeText={(changed) => {
                      const numericValue = changed.replace(/[^0-9]/g, "");
                      setWhatsNewDetails({
                        ...whatsNewDetails,
                        maxDisplayDuration: numericValue,
                      });
                      if (errorMessage.maxDisplayDuration) {
                        setErrorMessage({
                          ...errorMessage,
                          maxDisplayDuration: "",
                        });
                      }
                    }}
                    placeholder="60"
                    type="number"
                    isRequired
                    errorMessage={errorMessage.maxDisplayDuration}
                  ></Input>
                  <span
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "500",
                      pointerEvents: "none",
                    }}
                  >
                    Days
                  </span>
                </div>
              </div>
              <div className="each--section">
                <Caption>
                  Element identifier{" "}
                  {whatsNewDetails.featureUpdateType === "Major" && (
                    <span style={{ color: "#666" }}>
                      (disabled for major updates)
                    </span>
                  )}
                  {whatsNewDetails.featureUpdateType === "Minor" && (
                    <span style={{ color: "#666" }}>(optional)</span>
                  )}
                </Caption>
                <Input
                  value={whatsNewDetails.featureTag}
                  onChangeText={(changed) => {
                    setWhatsNewDetails({
                      ...whatsNewDetails,
                      featureTag: changed,
                    });
                  }}
                  placeholder="#render_button, .mainButton etc"
                  state={
                    whatsNewDetails.featureUpdateType === "Major"
                      ? "disabled"
                      : "none"
                  }
                ></Input>
                {whatsNewDetails.featureUpdateType === "Minor" && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "6px",
                      lineHeight: "1.4",
                    }}
                  >
                    For testing purposes only. Searches for CSS selectors like
                    #elementId or .className in the DOM.
                  </div>
                )}
              </div>
              <div className="each--section">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                  }}
                >
                  <Caption>
                    {whatsNewDetails.featureUpdateType === "Minor"
                      ? "Feature Tag Route"
                      : "Page URL for popup visibility"}{" "}
                    {whatsNewDetails.featureUpdateType === "Major" && (
                      <span style={{ color: "#666" }}>(optional)</span>
                    )}
                    {whatsNewDetails.featureUpdateType === "Minor" && (
                      <span style={{ color: "#666" }}>(optional)</span>
                    )}
                  </Caption>
                  {!(
                    whatsNewDetails.module.length === 1 &&
                    whatsNewDetails.module[0] === "Manifest"
                  ) && (
                      <span
                        onClick={addPageUrl}
                        style={{
                          color: "#7C3AED",
                          fontSize: "14px",
                          cursor: "pointer",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                      >
                        + Add URL
                      </span>
                    )}
                </div>
                {whatsNewDetails.module.length === 1 &&
                  whatsNewDetails.module[0] === "Manifest" && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: "8px",
                        lineHeight: "1.4",
                      }}
                    >
                      For Manifest module, major popups are restricted to /home
                      path only. This field is read-only.
                    </div>
                  )}
                {whatsNewDetails.pageUrls.map((url, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginBottom: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Input
                        value={url}
                        onChangeText={(changed) =>
                          updatePageUrl(index, changed)
                        }
                        placeholder="/settings/channel-settings"
                        state={
                          whatsNewDetails.module.length === 1 &&
                            whatsNewDetails.module[0] === "Manifest"
                            ? "disabled"
                            : "none"
                        }
                      />
                    </div>
                    {whatsNewDetails.pageUrls.length > 1 &&
                      !(
                        whatsNewDetails.module.length === 1 &&
                        whatsNewDetails.module[0] === "Manifest"
                      ) && (
                        <div
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #e0e0e0",
                            transition: "background-color 0.2s ease",
                          }}
                          onClick={() => removePageUrl(index)}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#eeeeee";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#f5f5f5";
                          }}
                        >
                          <DeleteIcon width="20" height="20" color="#666666" />
                        </div>
                      )}
                  </div>
                ))}
              </div>
              <div className="each--section">
                <Input
                  labelText="Primary button text"
                  isRequired
                  value={whatsNewDetails.primaryButton.text}
                  onChangeText={(changed) => {
                    if (
                      changed.length >
                      WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH
                    ) {
                      setErrorMessage({
                        ...errorMessage,
                        primaryButtonText: `Button text must not exceed ${WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH} characters`,
                      });
                    } else {
                      setWhatsNewDetails({
                        ...whatsNewDetails,
                        primaryButton: {
                          ...whatsNewDetails.primaryButton,
                          text: changed,
                        }
                      });
                      if (errorMessage.primaryButtonText) {
                        setErrorMessage({
                          ...errorMessage,
                          primaryButtonText: "",
                        });
                      }
                    }
                  }}
                  placeholder="Learn More"
                  errorMessage={errorMessage.primaryButtonText}
                  maxCharLimit={WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH}
                ></Input>
              </div>
              <div className="each--section">
                <Caption>
                  Primary button action
                </Caption>
                <Dropdown
                  options={PrimaryButtonActionList}
                  placeHolder="Select action"
                  onSelect={(option) => {
                    const selectedValue = (option as SingleOption)["value"];
                    setPrimaryButtonActionList(
                      PrimaryButtonActionList.map((item) => ({
                        ...item,
                        selected: selectedValue === item.value,
                      }))
                    );
                    setWhatsNewDetails({
                      ...whatsNewDetails,
                      primaryButton: {
                        ...whatsNewDetails.primaryButton,
                        action: selectedValue as PrimaryButtonAction,
                      }
                    });
                  }}
                ></Dropdown>
              </div>
              <div className="each--section">
                <Caption>
                  Primary button redirection URL <span style={{ color: "red" }}>*</span>
                </Caption>
                <Input
                  value={whatsNewDetails.primaryButton.redirectionUrl}
                  onChangeText={(changed) => {
                    setWhatsNewDetails({
                      ...whatsNewDetails,
                      primaryButton: {
                        ...whatsNewDetails.primaryButton,
                        redirectionUrl: changed,
                      }
                    });
                    if (errorMessage.primaryButtonRedirectionUrl) {
                      setErrorMessage({
                        ...errorMessage,
                        primaryButtonRedirectionUrl: "",
                      });
                    }
                  }}
                  placeholder="/settings/channel-settings"
                  errorMessage={errorMessage.primaryButtonRedirectionUrl}
                ></Input>
              </div>
              <div className="each--section">
                <Input
                  labelText="Secondary button text"
                  isRequired
                  value={whatsNewDetails.secondaryButton.text}
                  onChangeText={(changed) => {
                    if (
                      changed.length >
                      WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH
                    ) {
                      setErrorMessage({
                        ...errorMessage,
                        secondaryButtonText: `Button text must not exceed ${WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH} characters`,
                      });
                    } else {
                      setWhatsNewDetails({
                        ...whatsNewDetails,
                        secondaryButton: {
                          ...whatsNewDetails.secondaryButton,
                          text: changed,
                        }
                      });
                      if (errorMessage.secondaryButtonText) {
                        setErrorMessage({
                          ...errorMessage,
                          secondaryButtonText: "",
                        });
                      }
                    }
                  }}
                  placeholder="Learn More"
                  errorMessage={errorMessage.secondaryButtonText}
                  maxCharLimit={WHATS_NEW_VALIDATION.BUTTON_TEXT_MAX_LENGTH}
                ></Input>
              </div>
              <div className="each--section">
                <Caption>
                  Secondary button action <span style={{ color: "red" }}>*</span>
                </Caption>
                <Dropdown
                  options={SecondaryButtonActionList}
                  placeHolder="Select action"
                  onSelect={(option) => {
                    const selectedValue = (option as SingleOption)["value"] as SecondaryButtonAction;
                    setSecondaryButtonActionList(
                      SecondaryButtonActionList.map((item) => ({
                        ...item,
                        selected: selectedValue === item.value,
                      }))
                    );
                    setWhatsNewDetails({
                      ...whatsNewDetails,
                      secondaryButton: {
                        ...whatsNewDetails.secondaryButton,
                        action: selectedValue,
                      }
                    });
                    setErrorMessage({
                      ...errorMessage,
                      secondaryButtonAction: "",
                    });
                  }}
                  error={errorMessage.secondaryButtonAction}
                ></Dropdown>
              </div>
              <div className="each--section">
                <Caption>
                  Secondary button redirection URL
                </Caption>
                <Input
                  value={whatsNewDetails.secondaryButton.redirectionUrl}
                  onChangeText={(changed) => {
                    setWhatsNewDetails({
                      ...whatsNewDetails,
                      secondaryButton: {
                        ...whatsNewDetails.secondaryButton,
                        redirectionUrl: changed,
                      }
                    });
                    if (errorMessage.secondaryButtonRedirectionUrl) {
                      setErrorMessage({
                        ...errorMessage,
                        secondaryButtonRedirectionUrl: "",
                      });
                    }
                  }}
                  placeholder="/settings/channel-settings"
                  errorMessage={errorMessage.secondaryButtonRedirectionUrl}
                  state={
                    whatsNewDetails.secondaryButton.action === SecondaryButtonAction.CLOSE_POPUP ||
                      whatsNewDetails.secondaryButton.action === SecondaryButtonAction.NONE
                      ? "disabled"
                      : "none"
                  }
                ></Input>
                {whatsNewDetails.secondaryButton.action === SecondaryButtonAction.OPEN_LINK && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "6px",
                      lineHeight: "1.4",
                    }}
                  >
                    Optional - Leave empty to close popup
                  </div>
                )}
                {(whatsNewDetails.secondaryButton.action === SecondaryButtonAction.CLOSE_POPUP ||
                  whatsNewDetails.secondaryButton.action === SecondaryButtonAction.NONE) && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "6px",
                        lineHeight: "1.4",
                      }}
                    >
                      Not needed for "{whatsNewDetails.secondaryButton.action || 'Close popup'}" action
                    </div>
                  )}
              </div>
              <div className="each--section">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                  }}
                >
                  <Caption>
                    Display image <span style={{ color: "red" }}>*</span>
                  </Caption>
                  {whatsNewDetails.displayImage && (
                    <div style={{ display: "flex", gap: "12px" }}>
                      <span
                        onClick={() => setShowImageUploadModal(true)}
                        style={{
                          color: "#7C3AED",
                          fontSize: "14px",
                          cursor: "pointer",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                      >
                        Replace
                      </span>
                      <span
                        onClick={() => {
                          setWhatsNewDetails({
                            ...whatsNewDetails,
                            displayImage: "",
                          });
                        }}
                        style={{
                          color: "#EF4444",
                          fontSize: "14px",
                          cursor: "pointer",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                      >
                        Remove
                      </span>
                    </div>
                  )}
                </div>

                {!whatsNewDetails.displayImage && (
                  <div
                    onClick={() => setShowImageUploadModal(true)}
                    style={{
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      cursor: "pointer",
                      backgroundColor: "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      transition: "border-color 0.2s ease",
                      minHeight: "44px",
                      boxSizing: "border-box",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#7C3AED";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#d1d5db";
                    }}
                  >
                    <ShapeIcon width="20" height="20" fill="#731DCF" />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#731DCF",
                      }}
                    >
                      Add Image
                    </span>
                  </div>
                )}

                {errorMessage.displayImage && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {errorMessage.displayImage}
                  </div>
                )}

                {whatsNewDetails.displayImage && (
                  <div
                    style={{
                      marginTop: whatsNewDetails.displayImage ? "12px" : "0px",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#f9fafb",
                    }}
                  >
                    <img
                      src={whatsNewDetails.displayImage}
                      alt="Display preview"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "6px",
                    lineHeight: "1.4",
                  }}
                >
                  Recommended ratio: {WHATS_NEW_VALIDATION.IMAGE_RATIO.DISPLAY}
                </div>
              </div>
              <div className="each--section">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                  }}
                >
                  <Caption>
                    Product video{" "}
                    <span style={{ color: "#666" }}>(optional)</span>
                  </Caption>
                  {whatsNewDetails.productVideo && (
                    <div style={{ display: "flex", gap: "12px" }}>
                      <span
                        onClick={() => setShowVideoUploadModal(true)}
                        style={{
                          color: "#7C3AED",
                          fontSize: "14px",
                          cursor: "pointer",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                      >
                        Replace
                      </span>
                      <span
                        onClick={() => {
                          setWhatsNewDetails({
                            ...whatsNewDetails,
                            productVideo: "",
                          });
                        }}
                        style={{
                          color: "#EF4444",
                          fontSize: "14px",
                          cursor: "pointer",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                      >
                        Remove
                      </span>
                    </div>
                  )}
                </div>

                {!whatsNewDetails.productVideo && (
                  <div
                    onClick={() => setShowVideoUploadModal(true)}
                    style={{
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      cursor: "pointer",
                      backgroundColor: "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      minHeight: "44px",
                      boxSizing: "border-box",
                      width: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#7C3AED";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#d1d5db";
                    }}
                  >
                    <ShapeIcon width="20" height="20" fill="#731DCF" />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#731DCF",
                      }}
                    >
                      Add Video
                    </span>
                  </div>
                )}

                {errorMessage.productVideo && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {errorMessage.productVideo}
                  </div>
                )}

                {whatsNewDetails.productVideo && (
                  <VideoPlayer src={whatsNewDetails.productVideo} />
                )}
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "6px",
                    lineHeight: "1.4",
                  }}
                >
                  <strong>Note:</strong> If no product video URL is provided,
                  the feature will only be added to the What&apos;s New list
                  without showing a popup.
                  {bodyText.body && bodyText.body.includes("<") && (
                    <div style={{ marginTop: "4px", color: "#EF4444" }}>
                      <strong>⚠️ Important:</strong> Your content contains
                      HTML. Please test the popup preview before activating
                      visibility to ensure proper rendering.
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {curentMenu !== MenuItems[2].key && (
            <div className="each--section">
              <Input
                labelText="Feature description"
                value={formDetails.desc}
                onChangeText={(changed) => {
                  determineErrorMessage(changed, "desc");
                  setFormDetails({ ...formDetails, desc: changed });
                }}
                maxCharLimit={1024}
                type="multiline"
                isRequired
                errorMessage={errorMessage.desc}
              ></Input>
            </div>
          )}
          {curentMenu !== MenuItems[2].key && (
            <div className="each--section">
              <Caption>Image</Caption>

              <div
                className="flex--row"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                {formDetails.image && (
                  <div className="image-panel">
                    <BackgroundImageContainer
                      imageUrl={formDetails.image}
                      height="200px"
                    />
                  </div>
                )}
                <div className="upload--image" style={{ width: "100%" }}>
                  <UploadFile
                    type={"Image"}
                    onFileUpload={(fileMetaData) => {
                      setFormDetails({
                        ...formDetails,
                        image: fileMetaData.mediaUrl,
                      });
                    }}
                    channel={"whatsapp"}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="each--section">
            <Button
              buttonText="Submit"
              onClick={submitAllFeatureDetails}
              matchParentWidth
              size="medium"
              isLoading={updating}
            ></Button>
          </div>
        </AddOrEditFeatureModalContainer>
      </StyledModal>

      {/* Upload Modals */}
      <ImageUploadModal
        isOpen={showImageUploadModal}
        onClose={() => setShowImageUploadModal(false)}
        onImageUpload={(imageUrl) => {
          setWhatsNewDetails({
            ...whatsNewDetails,
            displayImage: imageUrl,
          });
          setErrorMessage({
            ...errorMessage,
            displayImage: "",
          });
        }}
      />

      <VideoUploadModal
        isOpen={showVideoUploadModal}
        onClose={() => setShowVideoUploadModal(false)}
        onVideoUpload={(videoUrl) => {
          setWhatsNewDetails({
            ...whatsNewDetails,
            productVideo: videoUrl,
          });
          setErrorMessage({
            ...errorMessage,
            productVideo: "",
          });
        }}
      />
    </>
  );
};

export default AddOrEditFeatureModal;
